import React from 'react';
import cbmis from '../Image/cbmis.svg';
import sda from '../Image/Header_Logo.png';
function Experience() {
  const experiences = [
    {
      title: "Part time - Software Engineer",
      company: "CBM Integrated Software Inc.",
      period: "2020 - Present",
      description: `I worked with CBMIS as a Machine Learning Engineer, Researcher, and Software Engineer, where I leveraged my expertise in ReactJS and Python to create impactful solutions for the company. In this role, I was responsible for developing and implementing machine learning algorithms and models, researching new technologies and techniques, and creating software solutions that integrate these models and algorithms into CBMIS's products and services. I demonstrated a strong ability to develop scalable and robust software solutions while adhering to best coding practices and design patterns. I also used my skills in machine learning to create more than six models and publish six research papers in prestigious journals such as IEEE. Furthermore, I developed an AI toolbox that facilitated research for other researchers and education, further demonstrating my expertise in machine learning and artificial intelligence.`,
      img: cbmis
    },
    {
      title: "Full time - Full stack programmer and analytic",
      company: "Irbid District Electricity Company",
      period: "2019 - Present",
      description: `As a full-time programmer and analyst, I worked with IDECO, where I used my skills as a full-stack programmer to build web and mobile apps with ASP.Net core and Flutter. As a part of this, I work in this role, developing the front-end and back-end components of these applications making sure that the pieces all fit seamlessly together. Some of the things you gained experience with on IDECO during your time, were ASP.Net MVC, Flutter, and other useful technologies/frameworks. As a full-stack programmer and analyst in IDECO, I demonstrated a strong ability to work on scalable and robust applications whilst maintaining best coding practices and design patterns. I provided valuable contributions to IDECO's successful delivery of several web and mobile applications and was a much sought-after problem solver and communicator by both my peers and customers.`,
      img: sda
    }
  ];

  return (
    <section id="experience" className="section">
      <h2>Experience</h2>
      {experiences.map((exp, index) => (
        <div key={index} className="experience-item">
          <div className="experience-text">
            <h3>{exp.title}</h3>
            <h4>{exp.company}</h4>
            <p className="period">{exp.period}</p>
            <p>{exp.description}</p>
          </div>
          <img src={exp.img.toString()} alt={exp.title} />
        </div>
      ))}
    </section>
  );
}

export default Experience;
